import { HttpClient } from '@angular/common/http';
import { Component, ElementRef, ViewChild } from '@angular/core';
import { AlertService } from 'src/app/services/alert.service';


@Component({
  selector: 'app-get-link',
  templateUrl: './get-link.component.html',
  styleUrls: ['./get-link.component.scss']
})
export class GetLinkComponent {



  constructor(private http: HttpClient,
    private alert: AlertService
  ) {
    this.getLink();
  }

  textURi: string = ""
  getLink() {
    this.http.get('open/url').subscribe({
      next: (res: any) => {
        this.textURi = res.data;
      }
    })
  }

  copyText() {
    navigator.clipboard.writeText(this.textURi).then(() => {
      this.alert.notify('คัดลอกแล้ว', 'success')
      // alert('คัดลอกแล้ว!');
    }).catch(err => {
      console.error('ไม่สามารถคัดลอกได้: ', err);
    });
  }
}
